// Term calendar dialog helpers (design plan revision R6). Pure functions so
// the month-ownership and date-picker rules can be unit tested.

const locale = (language) => (language === "ar" ? "ar" : "en");

// Month name and two-digit year shown on a term calendar chip (R6.3).
export const chipParts = (value, language) => {
  const date = new Date(`${value}-01T00:00:00`);
  return {
    month: date.toLocaleDateString(locale(language), { month: "short" }),
    year: date.toLocaleDateString(locale(language), { year: "2-digit" }),
  };
};

// Label of the other period that already holds ``month``, or null. ``self``
// is the period being edited: { kind: "term" | "vacation", index }.
export const monthOwner = (month, terms, vacations, self, language) => {
  const other = (kind, rows) => rows.find((row, i) => !(self?.kind === kind && self?.index === i) && row.months.includes(month));
  const owner = other("term", terms) || other("vacation", vacations);
  if (!owner) return null;
  return (language === "ar" && owner.label_ar) || owner.label || owner.key || "";
};

// Toggle ``month`` on one period. A month held by another period is left
// where it is; it must be unticked there first (R6.2).
export const toggleOwnMonth = (terms, vacations, kind, index, month) => {
  if (monthOwner(month, terms, vacations, { kind, index }) !== null) return { terms, vacations };
  const apply = (rows) => rows.map((row, i) => (i !== index ? row : {
    ...row,
    months: row.months.includes(month) ? row.months.filter((m) => m !== month) : [...row.months, month].sort(),
  }));
  return kind === "term" ? { terms: apply(terms), vacations } : { terms, vacations: apply(vacations) };
};

// Month an instalment due-date picker opens on (R6.4): its own date, else
// instalment 1's month for instalment 2, else the term's first month.
export const pickerOpenMonth = (row, slot) => {
  const own = row?.due?.[slot];
  if (own) return own.slice(0, 7);
  if (slot > 0 && row?.due?.[0]) return row.due[0].slice(0, 7);
  return row?.months?.[0] || undefined;
};

// Year list for the due-date pickers: the academic year plus one either side.
export const pickerYearRange = (year) => {
  if (!year?.start_date || !year?.end_date) return {};
  return {
    fromYear: Number(year.start_date.slice(0, 4)) - 1,
    toYear: Number(year.end_date.slice(0, 4)) + 1,
  };
};
